import httpApiApplication from 'app/http/httpApiApplication';
const baseUrl = 'documents';
export const uploadFile = (values: any, name?: string) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data'
    }
  };
  return httpApiApplication.postCfg(baseUrl + '?' + 'name=' + name, values, config);
};
export const downloadFile = (id: string) => {
  return httpApiApplication.get(baseUrl + '/' + id);
};

export const removeFile = (id: string) => {
  return httpApiApplication.delete(baseUrl + '/' + id);
};
